(function () {
    'use strict';
    angular.module('Directives').directive('bbaQuoteOverrideSettings', bbaQuoteOverrideSettings);
    bbaQuoteOverrideSettings.$inject = [];
    function bbaQuoteOverrideSettings() {
        return {
            retstrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-quote-override-settings.html',
            scope: {
                step: '=',
                init: '='
            },
            controller: bbaQuoteOverrideSettingsController,
            controllerAs: 'vm',
            bindToController: true
        }

        function bbaQuoteOverrideSettingsController() {
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaQuoteOverrideSettings.js